import React from "react";
import { Questions, Team } from "../utils/types";
import QuestionView from "./QuestionView";

export default function QuestionsAnswers({
  teams,
  questions,
  updateTeams
}: {
  teams: Team[];
  updateTeams:Function;
  questions: Questions[];
}) {
  return (
    <article className="questions-container">
      {questions.map((question) => (
        <QuestionView key={question.id} updateTeams={updateTeams} question={question} teams={teams} />
      ))}
    </article>
  );
}
